import React from "react";

export default function GridSection({ children, extraClass }) {
  return (
    <div
      className={`grid 
        gap-6 md:gap-16
        mx-auto  
     ${extraClass}`}
    >
      {children}
    </div>
  );
}
